import { render } from "./SectionStatements.vue?vue&type=template&id=7b1d261c"
import script from "./SectionStatements.vue?vue&type=script&lang=js"
export * from "./SectionStatements.vue?vue&type=script&lang=js"

import "./SectionStatements.vue?vue&type=style&index=0&id=7b1d261c&lang=css"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__